// extracted by mini-css-extract-plugin
export default {"Container":"extension_Container__N3NRf","section-1":"extension_section-1__iH78N","content":"extension_content__M3j1+","section-2":"extension_section-2__yRj5G"};